import styled from 'styled-components'

export const PriceWrap = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  ${({ unavailable }) => unavailable && 'opacity: 0.6;'}
`

export const RegularPrice = styled.span`
  text-decoration: line-through;
  color: #888;
  font-size: 14px;
  font-weight: 400;
`

export const SellingPrice = styled.span`
  font-weight: inherit;
`

export const PriceRange = styled.span`
  font-weight: inherit;
`
